// 1==> import external libraries
import React, { useEffect, useState } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Breadcrumbs,
  Button,
  Card,
  Link,
  Paper,
  Typography,
  TextField,
  InputBase,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  ListItemText,
  MenuItem,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

//2==> import internal component and modules

import { getPostbackAction } from "../../redux/toolkit/postback/postback";
import { dateFormatStartFun } from "../../helper/dateConverter";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import Body from "../../layout/Body";

//3==> import styles and css
import { useStyles } from "../../theme/theme";

import { chargebackAction } from "../../redux/toolkit/chargeback/chargeback";
import SearchIcon from "@mui/icons-material/Search";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/charge-back"
      >
        Charge Back
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      Charge Back{" "}
    </Typography>
  </Stack>
);

const ChargeBack = () => {
  const dispatch = useDispatch();
  const getChargeback = useSelector((state) => state.chargebackData);
  const { data, loading, total } = getChargeback;
  const blockAndUnBlockAdminSelector = useSelector(
    (state) => state.blockAndUnBlockAdmin
  );
  const { status, message } = blockAndUnBlockAdminSelector;
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [snack, setSnack] = useState(false);
  const classes = useStyles();
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const [userId, setUserId] = useState("");
  const [partnerId, setPartnerId] = useState("");
  const [tabValue, setTabValue] = useState(0); // 0 for publisher, 1 for user

  const partnerDetails = useSelector((state) => state.allPartnerWithoutLimit);
  const { loading: partnerLoading, data: partnerData } = partnerDetails;

  // Publisher Chargeback Columns
  const publisherColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 220,
    },
    // {
    //   field: "publisher_id",
    //   headerName: "Publisher",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 250,
    // },
    // {
    //   field: "app_id",
    //   headerName: "App",
    //   flex: 1,
    //   headerClassName: "super-app-theme--header",
    //   minWidth: 250,
    // },

    {
          field: "app_id",
          headerName: "App",
          flex: 1,
          headerClassName: "super-app-theme--header",
          minWidth: 250,
           renderCell: (params) => {
            return <Typography>{params?.row?.app_id?.app_name}</Typography>;
          },
        },
        
        {
          field: "publisherName",
          headerName: "Publisher Name",
          flex: 1,
          minWidth: 250,
          headerClassName: "super-app-theme--header",
          renderCell: (params) => {
            return <Typography>{params?.row?.publisher_id?.name}</Typography>;
          },
        },



    {
      field: "user",
      headerName: "User ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.user_id}</Typography>;
      },
    },

    {
      field: "trans_id",
      headerName: "Trans ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.trans_id}</Typography>;
      },
    },

    {
      field: "url",
      headerName: "URL",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          // <Typography>{params?.row?.user_id}</Typography>
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            {params.row.url}
          </div>
        );
      },
    },

    {
      field: "publisher_payout",
      headerName: "Publisher Payout",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 180,
      renderCell: (params) => {
        return Math.abs(params?.row?.publisher_payout).toFixed(4);
      },
    },

    {
      field: "user_payout",
      headerName: "User Payout",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      renderCell: (params) => {
        return Math.abs(params?.row?.user_payout || 0).toFixed(4);
      },
    },

    {
      field: "bonus_amount",
      headerName: "Bonus Amount",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
    },

    {
      field: "apiStatusCode",
      headerName: "Api Status Code",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
    },

    {
      field: "createdAt",
      headerName: "Created",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 230,
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.createdAt).format("YYYY-MM-DD hh:mm:ss A")}
          </Typography>
        );
      },
    },
  ];

  // User Chargeback Columns
  const userColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 220,
    },
    {
      field: "app_id",
      headerName: "App",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 250,
      renderCell: (params) => {
        return <Typography>{params?.row?.app_id?.app_name}</Typography>;
      },
    },
    {
      field: "user_id",
      headerName: "User ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "trans_id",
      headerName: "Trans ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "user_payout",
      headerName: "User Payout (USD)",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      renderCell: (params) => {
        return Math.abs(params?.row?.user_payout || 0).toFixed(4);
      },
    },
    {
      field: "publisher_payout",
      headerName: "Publisher Payout (USD)",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 180,
      renderCell: (params) => {
        return Math.abs(params?.row?.publisher_payout || 0).toFixed(4);
      },
    },
    {
      field: "bonus_amount",
      headerName: "Bonus Amount",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 120,
      renderCell: (params) => {
        return Math.abs(params?.row?.bonus_amount || 0).toFixed(4);
      },
    },
    {
      field: "createdAt",
      headerName: "Created",
      flex: 1,
      headerClassName: "super-app-theme--header",
      minWidth: 230,
      renderCell: (params) => {
        return (
          <Typography>
            {moment(params?.row?.createdAt).format("YYYY-MM-DD hh:mm:ss A")}
          </Typography>
        );
      },
    },
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setPageState({ page: 0, pageSize: 25 });
    // Fetch data for the new tab
    dispatch(
      chargebackAction({
        page: 0,
        limit: 25,
        startDate: date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate: date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        userId: userId,
        partnerId: partnerId,
        type: newValue === 0 ? 'publisher' : 'user',
      })
    );
  };

  const searchHandler = () => {
    dispatch(
      chargebackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: date?.startDate
          ? dateFormatStartFun(date?.startDate)
          : null,
        endDate: date?.endDate
          ? dateFormatStartFun(date?.endDate)
          : null,
        userId: userId,
        partnerId: partnerId,
        type: tabValue === 0 ? 'publisher' : 'user',
      })
    );
  };

  const handleChangePartner = (event) => {
    setPartnerId(event.target.value);
  };

  const dateWiseUser = () => {
    dispatch(
      chargebackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate:date?.startDate ? dateFormatStartFun(date?.startDate) : null,
        endDate:date?.endDate ? dateFormatStartFun(date?.endDate) : null,
        partnerId: partnerId,
        userId: userId,
        type: tabValue === 0 ? 'publisher' : 'user',
      })
    );
  };

  // useEffect
  useEffect(() => {
    dispatch(
      chargebackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: null,
        endDate: null,
        partnerId: null,
        userId: null,
        type: tabValue === 0 ? 'publisher' : 'user',
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize, tabValue]);

  useEffect(() => {
    dispatch(getAllPartnerActionNoLimit({}));
  }, []);

  return (
    <>
      <Helmet>
        <title>Real Opinion Admin | Charge Back</title>
      </Helmet>

      <Appbar breadcrumb={breadcrumb} />
      {/* <DrawerUI /> */}
      <Body>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Publisher Chargebacks" />
            <Tab label="User Chargebacks" />
          </Tabs>
        </Box>

        <Stack
          sx={{ mb: 1 }}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Stack direction={"row"} justifyContent={"space-between"}>
            <Paper
              component="form"
              sx={{
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 400,
                backgroundColor: "transparent",
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder="search By UserId"
                inputProps={{
                  "aria-label": "search By UserId",
                }}
                onChange={(e) => setUserId(e.target.value)}
              />
              <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                <SearchIcon onClick={searchHandler} />
              </IconButton>
            </Paper>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Min Data/Time"
              value={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, startDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Max Data/Time"
              value={date?.endDate}
              minDate={date?.startDate}
              maxDate={moment()}
              onChange={(newValue) => {
                setDate({ ...date, endDate: newValue });
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          

          <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="partner-select-label">Select Partner</InputLabel>
            <Select
              labelId="partner-select-label"
              id="partner-select"
              value={partnerId}
              onChange={handleChangePartner}
              input={<OutlinedInput label="Select Partner" />}
            >
              {partnerData.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  <ListItemText primary={item.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {((date.startDate && date.endDate) || partnerId) && (
            <Button variant="contained" onClick={dateWiseUser}>
              find data
            </Button>
          )}
        </Stack>

        <Card sx={{ my: 2 }}>
          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              rows={data}
              autoHeight
              columns={tabValue === 0 ? publisherColumns : userColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 50, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              // onCellClick={(params) => {
              //     setadmin_id(params?.row?._id)
              // }}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                // Toolbar: GridToolbar,
              }}
              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState((old) => ({ ...old, page: newPage }));
              }}
              onPageSizeChange={(newPageSize) =>
                setPageState((old) => ({ ...old, pageSize: newPageSize }))
              }
            />
          </Paper>
        </Card>

        {/* modals */}
      </Body>

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={status}
        message={message}
      />
    </>
  );
};

export default ChargeBack;
